import { Box, Text, Button } from '@streamelements/frontend-ui';
import { createFileRoute } from '@tanstack/react-router';
import { CopyIcon } from '../../components/Icons/CopyIcon';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../components/Tooltip';

export const Route = createFileRoute('/exception/$eventId')({
  component: ExceptionPage,
});

function ExceptionPage() {
  const { eventId } = Route.useParams();
  return (
    <Box
      css={{
        size: '100%',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
      }}
    >
      <Text.Subtitle weight="bold">An unexpected error occurred</Text.Subtitle>

      <Text.Body css={{ color: '$textPrimary50', px: '2rem', mb: '1rem' }}>
        We're sorry, but an unexpected error occurred while processing your request.
      </Text.Body>

      <Text.Body as="div" css={{ color: '$textPrimary50', px: '4rem' }}>
        Please include the following stack trace ID when contacting StreamElements support:
        <br />
        <Box
          css={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: '0.25rem',
            gap: '0.25rem',
            mt: '1rem',
            bgc: '$uiQuaternary',
            br: '0.25rem',
            border: '1px solid $divider',
          }}
        >
          <Text.Body
            as="code"
            css={{
              display: 'inline-block',
              padding: '0.125rem 0.25rem',
            }}
          >
            {eventId}
          </Text.Body>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                iconButton
                variant="ghost"
                color="neutral"
                aria-label="Copy trace ID"
                onClick={() => {
                  navigator.clipboard.writeText(eventId);
                }}
                css={{
                  minWidth: 'unset',
                  height: 'auto',
                  padding: '0.25rem',
                }}
              >
                <CopyIcon />
              </Button>
            </TooltipTrigger>
            <TooltipContent>Copy trace ID</TooltipContent>
          </Tooltip>
        </Box>
      </Text.Body>
    </Box>
  );
}
